import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.GetFilenameFilter,
    dependencies: [
    ]
})
export class GetFilenameFilter {
    constructor() {
        return ((path: string) => {

            let filename = path.substring(path.lastIndexOf("/") + 1);

            return filename;
        }) as any;
    }

}
